import { SrIcon } from "@/components/ui/SrIcon";

interface MyTasksListHeaderProps {
  title: string;
  totalCount: number;
  inProgressCount: number;
  expanded: boolean;
  onToggle: () => void;
}

/**
 * Collapsible header row for MyTasksList. Renders title, total count badge
 * and an "in progress" badge when there are active tasks.
 */
export function MyTasksListHeader({
  title,
  totalCount,
  inProgressCount,
  expanded,
  onToggle,
}: MyTasksListHeaderProps) {
  return (
    <button
      onClick={onToggle}
      className="w-full flex items-center justify-between p-4 hover:bg-muted/50 transition-colors"
    >
      <div className="flex items-center gap-3">
        <span className="font-display font-semibold text-lg tracking-tight">{title}</span>
        <span className="inline-flex items-center text-[12px] px-2 py-0.5 rounded-full border-[1.5px] border-foreground bg-card font-medium tabular-nums">
          {totalCount}
        </span>
        {inProgressCount > 0 && (
          <span className="inline-flex items-center gap-1.5 text-[12px] px-2 py-0.5 rounded-full border-[1.5px] border-foreground bg-[var(--sr-reveblaa)] text-white font-medium">
            {inProgressCount} pågår
          </span>
        )}
      </div>
      {expanded ? (
        <SrIcon name="chevron-up" className="w-4 h-4 text-muted-foreground" />
      ) : (
        <SrIcon name="chevron-down" className="w-4 h-4 text-muted-foreground" />
      )}
    </button>
  );
}

export default MyTasksListHeader;
